import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ClienteComboOutput, ClienteOperacaoOutput } from 'src/app/@shared/models/consulta-detalhe';

const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};

@Injectable({
  providedIn: 'root'
})
export class ModalLoadArquivoService {
  
  constructor(private http: HttpClient) { }

  
  public getClientesAtivos(): Observable<ClienteComboOutput[]> {
    return this.http.get<ClienteComboOutput[]>(`Load/GetClienteLoad`)
  }

  public getOperacao(clienteId: any): Observable<ClienteOperacaoOutput[]> {
    return this.http.get<ClienteOperacaoOutput[]>(`Load/GetOperacaoLoad?clienteId=${clienteId}`)
  }

  public UploadArquivoSalvar(body: any): Observable<any> {
    return this.http.post<any>(`Load/UploadFile`, body);
  }
 
}
